import React from 'react';

import { useRecordContext, TextField } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { PhoneNumberParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Telefonnummer',
  [languages.EN]: 'Phone Number',
  [languages.DE]: 'Telefonnummer',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const PhoneNumber = ({
  source,
  extraParameters,
}: {
  source?: string;
  extraParameters?: PhoneNumberParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source={source ?? 'phoneNumber'}
      datapoint={conflictFields.PHONE_NUMBER}
      identificationInfo={undefined}
    >
      <ValueField />
    </Answer>
  );
};

PhoneNumber.ValueField = ValueField;

export default PhoneNumber;
